/**
 * Ensures .image-parallax__stage min-height fits absolutely positioned anchors
 * (image + caption) on desktop parallax layout. Clears --image-parallax-content-min below 1350px.
 */
(function () {
  var KEY = '__imageParallaxStageHeight';
  var DESKTOP_MQ = '(min-width: 1350px)';
  var SAFETY_PX = 24;

  if (window[KEY]) {
    window[KEY].refresh(document);
    return;
  }

  var attached = new WeakSet();
  var observers = new WeakMap();
  var stageList = [];
  var resizeFallbackBound = false;

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function applyMeasuredMinHeight(stage) {
    var anchors = stage.querySelectorAll('.image-parallax__anchor');
    if (!anchors.length) {
      stage.style.removeProperty('--image-parallax-content-min');
      return;
    }
    var maxBottom = 0;
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var bottom = a.offsetTop + a.offsetHeight;
      if (bottom > maxBottom) maxBottom = bottom;
    }
    stage.style.setProperty('--image-parallax-content-min', Math.ceil(maxBottom + SAFETY_PX) + 'px');
  }

  function measureStage(stage) {
    if (stage.classList.contains('image-parallax__stage--empty')) {
      stage.style.removeProperty('--image-parallax-content-min');
      return;
    }
    if (!isDesktop()) {
      stage.style.removeProperty('--image-parallax-content-min');
      return;
    }
    applyMeasuredMinHeight(stage);
    /* Second pass: raising min-height changes % top offsets, so bottoms can shift */
    requestAnimationFrame(function () {
      if (!attached.has(stage) || !isDesktop()) return;
      applyMeasuredMinHeight(stage);
    });
  }

  function measureAll() {
    for (var i = 0; i < stageList.length; i++) {
      measureStage(stageList[i]);
    }
  }

  function detach(stage) {
    var ro = observers.get(stage);
    if (ro) {
      ro.disconnect();
    }
    observers.delete(stage);
    attached.delete(stage);
    var idx = stageList.indexOf(stage);
    if (idx !== -1) stageList.splice(idx, 1);
    stage.style.removeProperty('--image-parallax-content-min');
  }

  function attach(stage) {
    if (attached.has(stage)) return;
    attached.add(stage);
    stageList.push(stage);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        measureStage(stage);
      });
      ro.observe(stage);
      var anchors = stage.querySelectorAll('.image-parallax__anchor');
      for (var i = 0; i < anchors.length; i++) {
        ro.observe(anchors[i]);
      }
      observers.set(stage, ro);
    } else {
      observers.set(stage, null);
      if (!resizeFallbackBound) {
        resizeFallbackBound = true;
        window.addEventListener('resize', measureAll);
      }
    }

    measureStage(stage);
  }

  function refresh(root) {
    var rootEl = root && root.querySelector ? root : document;
    var stages = rootEl.querySelectorAll('.image-parallax__stage:not(.image-parallax__stage--empty)');
    for (var i = 0; i < stages.length; i++) {
      attach(stages[i]);
    }
  }

  function onSectionUnload(event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    var stages = target.querySelectorAll('.image-parallax__stage');
    for (var i = 0; i < stages.length; i++) {
      detach(stages[i]);
    }
  }

  function initOnce() {
    var mq = window.matchMedia(DESKTOP_MQ);
    mq.addEventListener('change', measureAll);

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('.image-parallax__stage')) {
        refresh(e.target);
      }
    });
    document.addEventListener('shopify:section:unload', onSectionUnload);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measureAll();
      });
    }

    window.addEventListener('load', measureAll);
  }

  window[KEY] = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      document.removeEventListener('DOMContentLoaded', onReady);
      initOnce();
      refresh(document);
    });
  } else {
    initOnce();
    refresh(document);
  }
})();
